import { useLocation } from 'wouter'
import { Button } from '@/components/ui/button'
import { Sparkles, PartyPopper, Palmtree, ArrowRight } from 'lucide-react'
import Header from '../components/Header'

export default function BanxaCheckoutPage() {
	const [, navigate] = useLocation()

	return (
		<div className="min-h-screen bg-[#18181B]">
			<Header/>

			<div className="px-4 py-8 max-w-md mx-auto">
				<div className="text-center space-y-8">
					{/* Fun animated icon cluster */}
					<div className="relative flex justify-center items-center py-8">
						<div className="absolute animate-pulse">
							<div className="w-32 h-32 rounded-full bg-gradient-to-r from-[#EF4444]/20 to-[#DC2626]/20 blur-xl"/>
						</div>
						<div className="relative flex items-center gap-2">
							<Palmtree className="h-12 w-12 text-emerald-400 animate-bounce" style={{ animationDelay: '0ms' }}/>
							<PartyPopper className="h-16 w-16 text-[#EF4444] animate-bounce" style={{ animationDelay: '150ms' }}/>
							<Sparkles className="h-12 w-12 text-yellow-400 animate-bounce" style={{ animationDelay: '300ms' }}/>
						</div>
					</div>

					{/* Welcome message */}
					<div className="space-y-4">
						<h1 className="text-3xl font-bold text-[#ffffff]">
							Welcome Back, VIP!
						</h1>
						<p className="text-lg text-[#BABABB]">
							Your transaction is being processed. Time to get back to paradise.
						</p>
						<p className="text-sm text-[#888888]">
							Tokens typically arrive within a few minutes. Check your wallet for updates!
						</p>
					</div>

					{/* CTA Button */}
					<div className="pt-4">
						<Button
							onClick={() => navigate('/')}
							className="group relative w-full bg-[#EF4444] hover:bg-[#DC2626] text-white font-semibold py-6 px-8 rounded-2xl shadow-lg shadow-[#EF4444]/25 transition-all duration-300 hover:shadow-xl hover:shadow-[#EF4444]/30 hover:scale-[1.02]"
						>
							<span className="flex items-center justify-center gap-3 text-lg">
								<Palmtree className="h-5 w-5"/>
								Return to My Wallet
								<ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1"/>
							</span>

							{/* Shine effect */}
							<div className="absolute inset-0 rounded-2xl overflow-hidden">
								<div className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-700 bg-gradient-to-r from-transparent via-white/20 to-transparent"/>
							</div>
						</Button>
					</div>

					{/* Subtle footer message */}
					<p className="text-xs text-[#888888] pt-8">
						Questions? Our concierge team is here to help.
					</p>
				</div>
			</div>
		</div>
	)
}